module.exports = __webpack_public_path__ + "static/media/driver.b03bf8fc.png";